import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslocoModule } from "@ngneat/transloco";
import { AdvancedAccountSetupService } from "../../services/advanced-account-setup.service";
import { AdvancedAccountSetupDialogData, AdvancedAccountStatus } from "../../types/advanced-account-setup.types";

@Component({
  selector: "app-advanced-account-setup-dialog",
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: "./advanced-account-setup-dialog.component.html",
  styleUrls: ["./advanced-account-setup-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AdvancedAccountSetupService]
})
export class AdvancedAccountSetupDialogComponent implements OnInit {
  private readonly data = inject<AdvancedAccountSetupDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject<MatDialogRef<AdvancedAccountSetupDialogComponent>>(MatDialogRef);
  private readonly service = inject(AdvancedAccountSetupService);
  private readonly destroyRef = inject(DestroyRef);

  protected readonly Status = AdvancedAccountStatus;
  protected readonly feature = this.data.feature;
  protected readonly titleKey = this.data.target.kind === "platform" ? "platformTitle" : "title";
  protected readonly status = this.service.status;
  protected readonly retrying = this.service.retrying;

  ngOnInit(): void {
    this.service.init(this.data.status);

    this.service.watchStatus(this.data.target).pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }

  protected retry(): void {
    this.service.retry(this.data.target).pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }

  protected open(): void {
    this.dialogRef.close();
    this.feature.open();
  }

  protected close(): void {
    this.dialogRef.close();
  }
}
